import { render, staticRenderFns } from "./ClassRank.vue?vue&type=template&id=37a5990e"
import script from "./ClassRank.vue?vue&type=script&lang=js"
export * from "./ClassRank.vue?vue&type=script&lang=js"
import style0 from "./ClassRank.vue?vue&type=style&index=0&id=37a5990e&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports